import { REGION_HIERARCHY, ALL_PROVINCES } from '@/mocks/regionData';

// 모든 시/도-구/시/군 조합을 평탄화한 배열 생성
const ALL_REGION_KEYS: string[] = [];
ALL_PROVINCES.forEach((province) => {
  (REGION_HIERARCHY[province] || []).forEach((district) => {
    ALL_REGION_KEYS.push(`${province} ${district}`);
  });
});

export const regionOptions = ALL_REGION_KEYS;

export const mockCaregivers = [
  {
    id: 'cg-001',
    user_id: 'user-001',
    name: '김은정',
    gender: '여',
    age: 52,
    experience_years: 8,
    hourly_rate: 18000,
    available_regions: ['서울 강남구', '서울 서초구', '서울 송파구'],
    certificates: ['간호조무사', '요양보호사 1급', '치매전문교육'],
    introduction: '8년차 간병인 김은정입니다. 특히 치매 환자분들을 많이 돌봐왔고, 가족처럼 정성껏 모시겠습니다. 병원간병, 가정간병 모두 가능합니다.',
    available_days: ['월', '화', '수', '목', '금'],
    available_times: ['주간(09-18)', '야간(18-09)'],
    is_active: true,
    total_matches: 47,
    rating_avg: 4.9,
    avatar_url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=face',
    latitude: 37.4979,
    longitude: 127.0276,
    earliest_start_date: '2026-06-13',
  },
  {
    id: 'cg-002',
    user_id: 'user-002',
    name: '박성호',
    gender: '남',
    age: 45,
    experience_years: 12,
    hourly_rate: 20000,
    available_regions: ['서울 강남구', '서울 서초구', '서울 용산구', '서울 성동구', '경기 수원시', '경기 성남시'],
    certificates: ['간호조무사', '응급처치교육', '재활간병전문'],
    introduction: '남성 간병인 박성호입니다. 12년 경력으로 중증 환자, 운동장애 환자분들의 재활 간병에 특화되어 있습니다. 휠체어 이동, 체위변경에 능숙합니다.',
    available_days: ['월', '화', '수', '목', '금', '토'],
    available_times: ['주간(09-18)', '풀타임(24시간)'],
    is_active: true,
    total_matches: 63,
    rating_avg: 4.8,
    avatar_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228df2d?w=200&h=200&fit=crop&crop=face',
    latitude: 37.2636,
    longitude: 127.0286,
    earliest_start_date: '2026-06-25',
  },
  {
    id: 'cg-003',
    user_id: 'user-003',
    name: '이미숙',
    gender: '여',
    age: 58,
    experience_years: 15,
    hourly_rate: 22000,
    available_regions: ['서울 마포구', '서울 은평구', '서울 서대문구'],
    certificates: ['간호조무사', '요양보호사 1급', '한국어능력시험', '노인심리상담사'],
    introduction: '15년 경력의 베테랑 간병인 이미숙입니다. 노인분들의 심리 상태를 잘 이해하고, 말벗이 되어드리는 것을 가장 중요하게 생각합니다. 목욕, 식사보조, 병원동행 모두 가능합니다.',
    available_days: ['월', '화', '수', '목', '금', '토', '일'],
    available_times: ['주간(09-18)', '야간(18-09)', '풀타임(24시간)'],
    is_active: true,
    total_matches: 89,
    rating_avg: 5.0,
    avatar_url: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face',
    latitude: 37.5547,
    longitude: 126.9126,
    earliest_start_date: '2026-06-14',
  },
  {
    id: 'cg-004',
    user_id: 'user-004',
    name: '최영수',
    gender: '남',
    age: 38,
    experience_years: 5,
    hourly_rate: 16000,
    available_regions: ['서울 동작구', '서울 관악구', '서울 영등포구', '서울 구로구'],
    certificates: ['요양보호사 2급', '응급처치교육'],
    introduction: '5년차 간병인 최영수입니다. 젊은 남성 간병인으로서 체력이 좋아 24시간 간병도 문제없습니다. 암 환자분들의 간병 경험이 많아 항암치료 동행 및 케어가 가능합니다.',
    available_days: ['월', '화', '수', '목', '금'],
    available_times: ['주간(09-18)', '풀타임(24시간)'],
    is_active: true,
    total_matches: 28,
    rating_avg: 4.7,
    avatar_url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=face',
    latitude: 37.4962,
    longitude: 126.9449,
    earliest_start_date: '2026-06-15',
  },
  {
    id: 'cg-005',
    user_id: 'user-005',
    name: '한정자',
    gender: '여',
    age: 61,
    experience_years: 20,
    hourly_rate: 25000,
    available_regions: ['서울 종로구', '서울 중구', '서울 용산구', '서울 성북구'],
    certificates: ['간호조무사', '요양보호사 1급', '치매전문교육', '암전문간병교육', '호스피스간병'],
    introduction: '20년 경력의 시니어 간병인 한정자입니다. 호스피스 간병, 말기 암 환자분들의 영적/심리적 케어에 특화되어 있습니다. 가족과의 소통을 중시하며, 고인과 가족 모두가 편안할 수 있도록 돕습니다.',
    available_days: ['월', '화', '수', '목', '금', '토', '일'],
    available_times: ['주간(09-18)', '야간(18-09)', '풀타임(24시간)'],
    is_active: true,
    total_matches: 112,
    rating_avg: 5.0,
    avatar_url: 'https://images.unsplash.com/photo-1554721299-e5534e706f07?w=200&h=200&fit=crop&crop=face',
    latitude: 37.5710,
    longitude: 126.9914,
    earliest_start_date: '2026-06-16',
  },
  {
    id: 'cg-006',
    user_id: 'user-006',
    name: '강민재',
    gender: '남',
    age: 33,
    experience_years: 3,
    hourly_rate: 15000,
    available_regions: ['경기 고양시', '서울 은평구'],
    certificates: ['요양보호사 2급'],
    introduction: '3년차 신입 간병인 강민재입니다. 할머니, 할아버지를 모시며 간병의 소중함을 일찍이 깨달았습니다. 정성껏 모시겠습니다. 비용은 협의 가능합니다.',
    available_days: ['토', '일'],
    available_times: ['주간(09-18)'],
    is_active: true,
    total_matches: 12,
    rating_avg: 4.6,
    avatar_url: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=face',
    latitude: 37.6584,
    longitude: 126.7730,
    earliest_start_date: '2026-06-20',
  },
];

export const certificateOptions = [
  '간호조무사', '요양보호사 1급', '요양보호사 2급',
  '치매전문교육', '응급처치교육', '재활간병전문',
  '노인심리상담사', '암전문간병교육', '호스피스간병',
  '한국어능력시험',
];

export const dayOptions = ['월', '화', '수', '목', '금', '토', '일'];
export const timeOptions = ['주간(09-18)', '야간(18-09)', '풀타임(24시간)'];